import {writable} from 'svelte/store';

export const selectedProjectIds = writable<Array<string>>([]);
